<!--
 * @Description: 
 * @Author: xiong.zhou@dmall.com
 * @Date: 2022-05-21 23:14:06
 * @LastEditors: xiong.zhou@dmall.com
 * @LastEditTime: 2024-11-04 23:51:32
-->
<template>
    <div class="material-content">
        <div class="title">
            <div class="title-text">推荐素材</div>
            <router-link class="check-more" target="_blank" to="/material">查看更多</router-link>
        </div>
        <div class="material-con">
            <div class="material-card" v-for="material in dataList" @click="setMaterial(material)">
                <el-card 
                    :body-style="{ padding: '20px 20px 10px 20px' }" 
                    shadow="hover">
                    <div class="material-card-img-area">
                        <img 
                            v-lazy="material.logo" 
                            class="image" />
                        <el-button 
                            class="hover-show download-btn" 
                            type="primary" >查看详情</el-button>
                        <!-- <div class="material-card-format">{{ material.formatList | filterName('、') }}</div> -->
                    </div>
                    <div class="material-card-info">
                        <div class="material-card-info-name" :title="material.name">{{ material.name }}</div>
                        <!-- <div class="material-card-info-category">{{ material.categoryList | filterName(' / ') }}</div> -->
                        <div class="material-card-info-addition">
                            <template v-if="material.price" >
                                <span v-if="material.paid" class="material-card-info-price-tag paid">已购买</span>
                                <span v-else class="material-card-info-price-tag needPay">￥{{material.price}}</span>
                                <div class="file-type">
                                    <img class="file-type-icon" v-for="item in (material.formatList ||[])" :src="iconList[item.name]"></img>
                                </div>
                            </template>
                            <span v-else class="material-card-info-price-tag free">免费</span>
                            <!-- <span style="float: right"><i class="el-icon-download"></i>{{ material.downloads }}</span> -->
                        </div>
                        <!-- <div class="material-card-info-tag">
                            <span 
                                v-for="(label, index) in material.labelList" 
                                :key="index"
                            >
                                #{{ label.name }}
                            </span>
                        </div> -->
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { getHotMaterial } from '@/api/home';
import { openWindow } from '@/utils/utils';

export default {
    name: 'HotMaterial',
    components: {
    },
    props: {
        type: {
            type: Number,
            default: 0
        }
    },
    filters: {
		filterName(list, format) {
			return list && list.map(item => item.name).join(format);
		}
	},
    data: () => ({
        dataList:[],
        iconList: {
            '3dmax': require('@/assets/images/fileIcon/3dmax.svg'),
            'aep': require('@/assets/images/fileIcon/aep.svg'),
            'ai': require('@/assets/images/fileIcon/ai.svg'),
            'blend': require('@/assets/images/fileIcon/blend.svg'),
            'c4d': require('@/assets/images/fileIcon/c4d.svg'),
            'cclibs': require('@/assets/images/fileIcon/cclibs.svg'),
            'fbx': require('@/assets/images/fileIcon/fbx.svg'),
            'fig': require('@/assets/images/fileIcon/fig.svg'),
            'obj': require('@/assets/images/fileIcon/obj.svg'),
            'psd': require('@/assets/images/fileIcon/psd.svg'),
            'sketch': require('@/assets/images/fileIcon/sketch.svg'),
            'svg': require('@/assets/images/fileIcon/svg.svg'),
            'unity': require('@/assets/images/fileIcon/unity.svg'),
            'png': require('@/assets/images/fileIcon/png.svg'),
            'unreal': require('@/assets/images/fileIcon/unreal.svg'),
            'babylon': require('@/assets/images/fileIcon/babylon.svg'),
            'threejs': require('@/assets/images/fileIcon/threejs.svg'),
            'tif': require('@/assets/images/fileIcon/tif.svg'),
            'xd': require('@/assets/images/fileIcon/xd.svg'),
            'pptx':require('@/assets/images/fileIcon/pptx.svg')
        }
    }),
    computed: {
        ...mapState('user', ['userInfo'])
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            getHotMaterial({
                pageNum: 1,
                pageSize: 15
            }).then(({ code, data }) => {
                console.log('data: ', data);
                if (code === 0) {
                    this.dataList = data.result;
                }
            });
        },
        setMaterial(material) {
			if (!material.id) {
				return;
			}
			openWindow(`/#/material/detail/${material.id}`)
		}
    }
};
</script>

<style lang="scss" scoped>
.material-content {
    width: 1600px;
    margin: 50px 0 40px 0;
    .title {
        // margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        .check-more {
            color: #9DA1B5;
            cursor: pointer;
            font-weight: 400;
            font-size: 18px;
        }
        .title-text {
            color: #333333;
            font-size: 26px;
            font-weight: 600;
        }
    }
    .material-con {
        display: flex;
        flex-wrap: wrap;
    }
    .material-card {
        margin-right: 25px;
        margin-top: 25px;
        width: 300px;
        height: 325px;
        &:nth-child(5n + 5) {
            margin-right: 0;
        }
        .el-card {
            border: none;
            height: 325px;
            padding: 0;
            border-radius: 8px;
            cursor: pointer;
            &.is-hover-shadow{
                transform: translate(0, 0);
                transition: transform .3s;

                &:hover {
                    box-shadow: 0 4px 12px rgba(0, 0, 0, .03), 0 8px 16px rgba(0, 0, 0, .02);
                    transform: translate(0, -5px);
                    .material-card-img-area img {
                        transform: scale(1.05);
                    }
                    .material-card-img-area .hover-show {
                        opacity: 1;
                    }
                    .material-card-info-name {
                        color: #2f54eb;
                    }
                }
            }
            /deep/ .el-card__body {
                padding: 0!important;
            }
        }
        &-img-area {
            position: relative;
            // margin-bottom: 20px;
            height: 244px;
            overflow: hidden;
            .image {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .hover-show {
                position: absolute;
                opacity: 0;
                transition: .5s;
            }
            .icon-collect-btn {
                left: 10px;
                top: 10px;
            }
            .download-btn {
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                box-shadow: 999px 999px 10px 0px rgba(0, 0, 0, .2);
                background: transparent;
                border: transparent;
                &-img {
                    margin-right: 5px;
                    width: 16px;
                    vertical-align: bottom;
                }
            }
        }
        &-format {
            position: absolute;
            bottom: 0;
            padding: 0 20px;
            background: rgba(0, 0, 0, .2);
            width: 100%;
            color: #fff;
            font-size: 12px;
            line-height: 40px;
        }
        &-info {
            padding: 10px 12px 14px 12px;
            &-name {
                @include ellipse(100%);
                font-size: 16px;
                margin-bottom: 8px;
                font-weight: 400;
            }
            &-addition {
                color: #999;
                font-size: 13px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .file-type {
                    display: flex;
                    align-items: center;
                }
                .file-type-icon {
                    width: 22px;
                    height: 22px;
                    margin-right: 3px;
                }
            }
            &-tag {
                margin: 9px 0 0 0;
                span {
                    margin: 0 8px 8px 0;
                    font-size: 12px;
                    color: #8C8C8C;
                }
            }
            &-price-tag {
                &.free {
                    color: #1BC8BC; 
                    font-weight: 600;
                }
                &.needPay, &.paid {
                    padding: 2px 0;
                    border-radius: 4px;
                    color: #fff; 
                    font-weight: 600;
                }
                &.needPay {
                    color: #eb793c;
				    font-size: 15px;
                }
                &.paid {
                    border: 1px solid #eb793c;
                    color: #eb793c;
                }
            }
        }
    }
}

// 小屏
@include mq($small) {
    .material-content {
        width: 1200px;

        .material-card {
            width: 228px;
            height: 260px;
            margin-right: 15px;

            &-img-area {
                height: 180px;
            }
            .el-card {
                height: 260px;
            }
        }
    }
}
// 小屏
@include mq($smaller) {
    .material-content {
        width: unset;
        .material-card {
            width: 219px;
            &:nth-child(4n + 4) {
                margin-right: 0;
            }
            &:nth-child(5n + 5) {
                margin-right: 15px;
            }
        }
    }
    
}
</style>
